export const DEFAULT_TIKTOK_METRIC_1 = ['ttFollowersCount'];
export const DEFAULT_TIKTOK_METRIC_2 = ['ttAvgViews'];
export const DEFAULT_TIKTOK_METRIC_3 = [
  'ttAvgViewsEngRate',
  'ttAvgEngagements',
];
